export { FileUpload } from './FileUpload.component';
